import { useLayoutEffect, useState } from "react";

// The shared app header is position: fixed while the content area underneath
// starts at the top of the viewport, so the page pads itself by however much
// of it the header covers (0 when the header is in normal flow).
export default function useFixedHeaderOverlap(pageRef) {
  const [overlap, setOverlap] = useState(0);

  useLayoutEffect(() => {
    const header = document.querySelector(".app-layout > .header");
    const page = pageRef.current;
    if (!header || !page) return undefined;

    const measure = () => {
      const position = window.getComputedStyle(header).position;
      const covered =
        position === "fixed" || position === "sticky"
          ? header.getBoundingClientRect().bottom - page.getBoundingClientRect().top
          : 0;
      setOverlap(Math.max(0, Math.round(covered)));
    };

    measure();
    window.addEventListener("resize", measure);
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    observer?.observe(header);
    return () => {
      window.removeEventListener("resize", measure);
      observer?.disconnect();
    };
  }, [pageRef]);

  return overlap;
}
